export class Product {
    productId: number;
    productName: string;
    businessChallenge: string;
    businessGroupCoverageCodes: string;
    businessOwnerId: number;
    businessValue: string;
    commsEmails: string;
    dappissueKey: string;
    dataClassificationDetailId: number;
    dataloadfrequency: string;
    dataClassification: string;
    description: string;
    designBoardApprovedStatus: string;
    designBoardApproverId: number;
    designBoardRef: string;
    disasterRecoveryClass: string;
    displayName: string;
    deliveryDateCommitted: string;
    deliveryDateExpected: string;
    icaaRef: string;
    isaRef: string;
    jmfid: string;
    expectedResponse: string;
    expNumOfConcUsers: number;
    expNumOfUsers: number;
    geoCoverageLevelIds: string;
    geoCoverageValueCodes: string;
    leadSmeid: number;
    platformId: number;
    productShortName: string;
    praorRefId: string;
    previousRfcid: string;
    productDeliveryStatusId: number;
    productManagerId: number;
    productOwnerId: number;
    refreshFrequency: string;
    rowLimitations: string;
    serviceId: number;
    serviceNowRfcid: string;
    smenotesProduct: string;
    solutionOverview: string;
    loadDate: string;
    loadFor: string;
    loadBy: string;
    modelPublished: boolean;
    refreshDate: string;
    deliveryDateExpectedAsText: string;
    deliveryDateCommittedAsText: string;
    loadDateAsText: string;
}
